export const SUPPORTED_LOCALES = ['ru', 'en', 'gr'];
export const DEFAULT_LOCALE = 'en';
const STORAGE_KEY = 'lang';
function isLocale(value) {
    return value !== null && SUPPORTED_LOCALES.includes(value);
}
export function getStoredLocale() {
    const stored = localStorage.getItem(STORAGE_KEY);
    return isLocale(stored) ? stored : DEFAULT_LOCALE;
}
export function setStoredLocale(locale) {
    localStorage.setItem(STORAGE_KEY, locale);
}
